import React from "react";
import {
	Button,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Spinner,
} from "reactstrap";

/**
 * Minimal enable modal (Option B): current Store only, DualLens-style cbfe modal.
 */
export default function MonitoringEnableModal({
	isOpen,
	onClose,
	onEnable,
	busy = false,
	error = null,
	websiteLabel = "",
	websiteId = null,
}) {
	const host = websiteLabel || "Current website";

	function handleClose() {
		if (busy) return;
		onClose?.();
	}

	function handleEnable() {
		if (busy) return;
		onEnable?.();
	}

	return (
		<Modal
			isOpen={isOpen}
			toggle={handleClose}
			centered
			size="md"
			className="monitoring__enable-modal"
			backdrop={busy ? "static" : true}
			keyboard={!busy}
		>
			<ModalHeader toggle={busy ? undefined : handleClose}>
				<i className="fas fa-chart-line text-primary me-2" />
				Enable monitoring
			</ModalHeader>
			<ModalBody>
				<p className="text-muted small mb-3">
					Start continuous monitoring for the website selected in Store. Change
					Store in the header to enable a different site.
				</p>
				<div className="monitoring__enable-website">
					{/* <span className="monitoring__enable-label">Website</span> */}
					<span className="monitoring__enable-website-host" title={host}>
						{host}
					</span>
				</div>

				{error ? (
					<div className="monitoring__enable-error mt-3" role="alert">
						{error}
					</div>
				) : null}

				{busy ? (
					<p className="text-muted small mb-0 mt-3">Enabling monitoring…</p>
				) : null}
			</ModalBody>
			<ModalFooter>
				<Button
					color="secondary"
					outline
					type="button"
					onClick={handleClose}
					disabled={busy}
				>
					Cancel
				</Button>
				<Button
					color="primary"
					type="button"
					onClick={handleEnable}
					disabled={busy || websiteId == null || websiteId === ""}
				>
					{busy ? (
						<>
							<Spinner size="sm" className="me-2" />
							Working…
						</>
					) : (
						"Enable monitoring"
					)}
				</Button>
			</ModalFooter>
		</Modal>
	);
}
